import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import StoreModal from "../components/StoreModal";
import SettingsModal from "../components/SettingsModal";
import Toast from "../components/Toast";
import { getSessionTicket, getCachedUserInfo } from "../services/api";
import { useAuth } from "../contexts/AuthContext";
import { BetbyProvider, BetbyWidget } from "../betby/index";
import { clearSessionTicketCache } from "../betby/models/auth/sessionTicketCache";

type CurrencyMode = "sc" | "gc";

interface ToastState {
  show: boolean;
  message: string;
}

const SDK_API = process.env.REACT_APP_SDK_API_BASE_URL;

const SportbookPage: React.FC = () => {
  const navigate = useNavigate();
  const { setShowLoginModal, setOnLoginSuccess } = useAuth();
  const [currentMode, setCurrentMode] = useState(
    localStorage.getItem("winburst-mode") || "sc",
  );
  const [showStore, setShowStore] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [showToast, setShowToast] = useState<ToastState>({
    show: false,
    message: "",
  });
  const [sdkTicket, setSdkTicket] = useState("");
  const isFetchingRef = React.useRef(false);

  // 获取 session ticket
  const fetchSdkTicket = useCallback(
    async (forceRefresh = false) => {
      // 如果不是强制刷新，且正在获取或有ticket，则跳过
      if (!forceRefresh && (isFetchingRef.current || sdkTicket)) return;

      try {
        isFetchingRef.current = true;
        const { email, userId } = getCachedUserInfo();

        if (!email || !userId) {
          throw new Error("User not logged in");
        }

        const gameCurrencyAlias = currentMode === "gc" ? "GC" : "SC";
        const ticketData = await getSessionTicket(
          email,
          userId,
          gameCurrencyAlias,
        );

        if (ticketData.session_ticket) {
          setSdkTicket(ticketData.session_ticket);
        } else {
          throw new Error("No SDK URL received");
        }
      } catch (error: any) {
        console.error("Initialization error:", error);
        setShowLoginModal(true);
        // if (
        //   error?.message === "User not logged in" ||
        //   error?.code === 400 ||
        //   error?.code === 4002
        // ) {
        //   showToastMessage("Session expired. Please login again.");
        //   setShowLoginModal(true);
        // } else {
        //   showToastMessage("Failed to load sportsbook");
        // }
      } finally {
        isFetchingRef.current = false;
      }
    },
    [currentMode, sdkTicket, setShowLoginModal],
  );

  // 初始化
  useEffect(() => {
    (window as any).setShowStore = () => setShowStore(true);
    const savedMode = localStorage.getItem("winburst-mode");
    if (savedMode) {
      setCurrentMode(savedMode as CurrencyMode);
    }

    // 设置登录成功回调
    setOnLoginSuccess(() => {
      setSdkTicket("");
      isFetchingRef.current = false;
      fetchSdkTicket();
    });
  }, [setOnLoginSuccess]);

  // 获取 ticket
  useEffect(() => {
    fetchSdkTicket();
  }, [fetchSdkTicket]);

  const switchMode = (mode: CurrencyMode) => {
    if (mode === currentMode) return;
    setCurrentMode(mode);
    localStorage.setItem("winburst-mode", mode);
    setSdkTicket(""); // 切换货币时重新获取 ticket
  };

  const showToastMessage = (message: string) => {
    setShowToast({ show: true, message });
    setTimeout(() => {
      setShowToast({ show: false, message: "" });
    }, 3000);
  };

  return (
    <div style={{ width: "100%", height: "100vh" }}>
      <main style={{ width: "100%", height: "100%" }}>
        {sdkTicket && (
          <BetbyProvider
            config={{
              apiBaseUrl: SDK_API,
            }}
            onLogin={() => setShowLoginModal(true)}
            onTokenExpired={() => {
              console.log("2222222222");
              // 刷新缓存并重新获取 session ticket
              clearSessionTicketCache();
              isFetchingRef.current = false;
              fetchSdkTicket(true);
            }}
            onRequestSessionTicket={async () => {
              console.log("1111111111");
              return "123";
            }}
            onBack={() => navigate("/")}
            onRecharge={() => setShowStore(true)}
            onCurrencyChange={(mode) => {
              localStorage.setItem("winburst-mode", mode);
            }}
          >
            <BetbyWidget
              key={sdkTicket}
              hideTopBar={false}
              basename="/sportsbook"
              sessionTicket={sdkTicket}
            />
          </BetbyProvider>
        )}
      </main>

      {/* <button
        className="settings-btn"
        onClick={() => setShowSettings(true)}
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          width: "50px",
          height: "50px",
          borderRadius: "50%",
          border: "none",
          background: "#4a90d9",
          color: "white",
          fontSize: "20px",
          cursor: "pointer",
          zIndex: 1000,
        }}
      >
        <i className="fas fa-cog"></i>
      </button> */}

      <StoreModal isOpen={showStore} onClose={() => setShowStore(false)} />

      <SettingsModal
        isOpen={showSettings}
        onClose={() => setShowSettings(false)}
        currentMode={currentMode}
        onModeChange={switchMode}
        btInstance={null}
        showToast={showToastMessage}
      />

      <Toast
        show={showToast.show}
        message={showToast.message}
        onClose={() => setShowToast({ show: false, message: "" })}
      />
    </div>
  );
};

export default SportbookPage;
